import React, { useState } from 'react';
import TopDriModal from './topdrimodal';

const Products = () => {
  const products = [
    // Individual Desiccants
    {
      image: './assets/imgs/UDC-1.jpg',
      name: 'Clay',
      description: [
        'Clay desiccants are made from naturally occurring minerals that have a high capacity for moisture adsorption.',
        'These desiccants are often used to prevent damage due to humidity during packaging, storage, and transport. Clay desiccants are considered non-toxic and environmentally friendly, making them a popular choice for moisture control.',
      ],
      category: 'Desiccants',
      images: ['./assets/imgs/UDC-1.jpg', './assets/imgs/UDC-2.jpg', './assets/imgs/UDC-3.jpg'],
    },
    {
      image: './assets/imgs/UDC-5.jpg',
      name: 'Silica Gel',
      description: [
        'Silica gel desiccants are materials made from silicon dioxide, which is a porous form of silica. These desiccants are commonly used to absorb moisture and control humidity in various applications. Silica gel is particularly effective at absorbing water vapor due to its high surface area and porous structure.',
        'UDC offers silica gel packets that come with moisture indicator beads that change color when saturated, signaling that the gel needs to be replaced',
        'Overall, silica gel desiccants are a popular choice for moisture control in a wide range of applications due to their effectiveness, reusability, and safety.',
      ],
      category: 'Desiccants',
      images: ['./assets/imgs/UDC-5.jpg', './assets/imgs/UDC-6.jpg', './assets/imgs/UDC-8.jpg', './assets/imgs/UDC-9.jpg', './assets/imgs/UDC-10.jpg'],
    },
    {
      image: './assets/imgs/UDC-14.jpg',
      name: 'Molecular Sieve',
      description: [
        'Molecular sieves are fast-drying desiccants that can selectively remove moisture and other molecules from gases or liquids based on their size and shape. They are typically made from various zeolites, which are hydrated aluminosilicate minerals with a highly ordered structure. This unique structure allows molecular sieves to have uniform pore sizes, enabling them to trap molecules of specific sizes while allowing others to pass through. These are commonly used in desiccant packets for electronics and other moisture-sensitive items.',
        'Molecular sieve desiccants are versatile and effective materials for drying and moisture control in a wide range of industrial and commercial applications.',
      ],
      category: 'Desiccants',
      images: ['./assets/imgs/UDC-14.jpg', './assets/imgs/UDC-15.jpg'],
    },
    {
      image: './assets/imgs/UDC-17.jpg',
      name: 'Activated Carbon',
      description: [
        'Activated carbon is ideal for removing unwanted odor and chemicals from the air or an enclosed space. These are produced from renewable materials, making it another environmentally friendly option.',
      ],
      category: 'Desiccants',
      images: ['./assets/imgs/UDC-17.jpg', './assets/imgs/UDC-18.jpg'],
    },
    {
      image: './assets/imgs/UDC-38.jpg',
      name: 'Top Dri Container Desiccants',
      description: [
        'is a desiccant that is used to absorb moisture within shipping containers to protect goods from humidity-related damage during transport and storage. By using Top-Dri, we meet our main goal to keep the environment dry, therefore safeguarding products during these processes.',
        'TOP-DRI is the most advanced solution to moisture. It will absorb and trap moisture before it causes any damage to your products.',
        'Its contents are so absorbent that it will keep on absorbing up to 300% of its own weight, guaranteeing longer protection from moisture. Top-Dri will keep the shipping environment dry, ensuring product integrity when the goods arrive at their destination.',
      ],
      category: 'Desiccants',
      images: ['./assets/imgs/UDC-38.jpg', './assets/imgs/UDC-38 (1).jpg'],
    },
    // Film Types
    {
      image: './assets/imgs/UDC-20.jpg',
      name: 'Plastic',
      description: [
        'Plastic films are durable and versatile, making them ideal for various packaging needs.',
        'They are available in different thicknesses and can be customized for specific applications.',
      ],
      category: 'Film Types',
      images: ['./assets/imgs/UDC-20.jpg', './assets/imgs/UDC-20 - Copy.jpg'],
    },
    {
      image: './assets/imgs/UDC-50.jpg',
      name: 'Opaque',
      description: [
        'Opaque films provide excellent protection for sensitive materials by blocking out light.',
        'They are often used in medical, food, and cosmetic industries for their light-blocking properties.',
      ],
      category: 'Film Types',
      images: ['./assets/imgs/UDC-50.jpg', './assets/imgs/UDC-50 - Copy.jpg'],
    },
    {
      image: './assets/imgs/UDC-19.jpg',
      name: 'Non-woven',
      description: [
        'Non-woven films are high-strength and lightweight, suitable for medical and industrial applications.',
        'They provide excellent durability and breathability, making them versatile for multiple uses.',
      ],
      category: 'Film Types',
      images: ['./assets/imgs/UDC-19.jpg', './assets/imgs/UDC-19 - Copy.jpg'],
    },
    {
      image: './assets/imgs/UDC-40.jpg',
      name: 'Tyvek',
      description: [
        'Tyvek films are lightweight, water-resistant, and durable, often used in industrial and medical packaging.',
        'Their unique properties make them ideal for protecting products from environmental hazards.',
      ],
      category: 'Film Types',
      images: ['./assets/imgs/UDC-40.jpg', './assets/imgs/UDC-40 - Copy.jpg'],
    },
    {
      image: './assets/imgs/UDC-45.jpg',
      name: 'Paper',
      description: [
        'Paper films are eco-friendly, sustainable options for packaging.',
        'They are perfect for brands that prioritize environmental responsibility while maintaining packaging quality.',
      ],
      category: 'Film Types',
      images: ['./assets/imgs/UDC-45.jpg', , './assets/imgs/UDC-45 - Copy.jpg'],
    },
    {
      image: './assets/imgs/UDC-61 (1).jpg',
      name: 'Customized Logo',
      description: [
        'Customized logo films allow businesses to create branded packaging that enhances their product presentation.',
        'These films are available in a range of designs and colors to meet specific branding needs.',
      ],
      category: 'Film Types',
      images: ['./assets/imgs/UDC-61 (1).jpg', './assets/imgs/UDC-61 (1) - Copy.jpg'],
    },
    // Oxygen Absorbers
    {
      image: './assets/imgs/UDC-36.jpg',
      name: 'Oxygen Absorbers',
      description: [
        'Oxygen absorbers are small packets used to remove oxygen from sealed containers. The presence of oxygen decreases the storage life of foods and causes oxidative deterioration. Removing oxygen in packaged food products stops the growth of micro-organisms that cause the color of the food to change and rancid odor to develop.	',
        'Oxygen absorbers will keep food products fresh and preserve their quality thus providing longer shelf life.',
      ],
      category: 'Oxygen Absorbers',
      images: ['./assets/imgs/UDC-33.jpg','./assets/imgs/UDC-34.jpg', './assets/imgs/UDC-35.jpg', './assets/imgs/UDC-36.jpg'],
    },
    // Ethylene Absorbers
    {
      image: './assets/imgs/UDC-51.jpg',
      name: 'Ethylene Absorbers',
      description: [
        'Ethylene absorbers are an effective solution for preserving the quality of fresh produce during long haul transportation and storage.',
        'This will slow down the ripening of fruits, vegetables, flowers and other fresh products. The packet is made of waterproof and breathable materials that allow safe contact to your produce.',
      ],
      category: 'Ethylene Absorbers',
      images: ['./assets/imgs/UDC-51.jpg', './assets/imgs/UDC-51 - Copy.jpg'],
    },
    // HIC
    {
      image: './assets/imgs/HIC-2 (1).jpg',
      name: 'Humidity Indicator Cards (HICs)',
      description: [
        'Humidity Indicator Cards are used to monitor humidity levels inside sealed packaging.',
        'They provide a cost-effective way to ensure that moisture-sensitive items remain protected during storage and transport.',
      ],
      category: 'HIC',
      images: ['./assets/imgs/HIC-1 (1).jpg', './assets/imgs/HIC-2 (1).jpg', './assets/imgs/HIC-5 (1).jpg'],
    },
    // Barrier Bags
    {
      image: './assets/imgs/UDC-63.png',
      name: 'Static Shielding Bags',
      description: [
        'Designed to protect against electrostatic damage providing Faraday Cage effect. Its four-layer construction offers tear and puncture resistance. It has excellent surface resistivity and static dissipative properties capable of reducing 5K Volts in less than 50 microseconds.',
        '',
      ],
      category: 'Barrier Bags',
      images: ['./assets/imgs/UDC-63.png'],
    },
    {
      image: './assets/imgs/UDC-62.png',
      name: 'Moisture Barrier Bags',
      description: [
        'These are designed specifically for the critical requirements of ESD and Moisture Sensitive devices, components and solder reflow process surface mount devices. It is suited for vacuum packing and nitrogen flush packaging. These are available in various thicknesses and customized sizes.',
        'Tested by a reputable independent laboratory, MOCON, it offers extremely low MVTR as compared to metallized bags. Meets the electrical and physical requirements of EIA 583, EIA 541, EIA 625 and MIL-B-81705C Type 1.',
      ],
      category: 'Barrier Bags',
      images: ['./assets/imgs/UDC-62.png'],
    },
  ];

  const categories = ['Desiccants', 'Film Types', 'Oxygen Absorbers', 'Ethylene Absorbers', 'HIC', 'Barrier Bags'];
  const [selectedCategory, setSelectedCategory] = useState('Desiccants');
  const [currentIndex, setCurrentIndex] = useState(0); // For Desktop Carousel
  const [visibleProducts, setVisibleProducts] = useState(4); // For Mobile Grid
  const [modalProduct, setModalProduct] = useState(null); // Track product for modal display

  const itemsToShow = 4; // Number of items to show in the carousel

  const filteredProducts = products.filter(
    (product) => product.category === selectedCategory
  );

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? 0 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex + itemsToShow >= filteredProducts.length
        ? prevIndex
        : prevIndex + 1
    );
  };

  const handleSeeMore = () => {
    setVisibleProducts((prev) => Math.min(prev + 4, filteredProducts.length));
  };

  const [showTopDriDetails, setShowTopDriDetails] = useState(false);

  const openModal = (product) => {
    setModalProduct(product);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setModalProduct(null);
    setShowTopDriDetails(false);
    document.body.style.overflow = 'auto';
  };

  const openTopDriDetails = () => {
    setShowTopDriDetails(true);
  };

  return (
    <section id="products" className="w-full min-h-screen bg-white flex justify-center items-center py-12">
      <div className="container mx-auto px-4">
        
        {/* Title and Subtitle */}
        <div className="text-center mb-12">
          <h2 className="text-lg font-semibold text-gray-500 uppercase tracking-wider">
            Our Products
          </h2>
          <h1 className="text-4xl font-semibold text-[#30779b] mt-3">
            Explore our Desiccant Solutions
          </h1>
          <p className="text-base text-gray-600 mt-2">
            Protecting your products from moisture and preserving product integrity
          </p>
        </div>

        {/* Category Buttons */}
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          {categories.map((category) => (
            <button
              key={category}
              className={`px-4 py-2 rounded-full text-sm font-semibold ${
                selectedCategory === category
                  ? 'bg-[#0a354a] text-white'
                  : 'bg-gray-200 text-gray-700'
              }`}
              onClick={() => {
                setSelectedCategory(category);
                setCurrentIndex(0); // Reset carousel index
                setVisibleProducts(4); // Reset visible products for mobile
              }}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Desktop View */}
        <div className="hidden md:flex relative w-full justify-center items-center">
          {currentIndex > 0 && (
            <button
              onClick={handlePrev}
              className="absolute left-0 text-gray-700 p-2 text-2xl hover:text-gray-900 transition-colors"
            >
              {'<'}
            </button>
          )}
          <div className="flex space-x-4 px-16 w-full justify-center">
            {filteredProducts
              .slice(currentIndex, currentIndex + itemsToShow)
              .map((product, index) => (
                <div
                  key={index}
                  className="w-[180px] sm:w-[220px] md:w-[250px] bg-white rounded-xl shadow-md overflow-hidden flex flex-col justify-between"
                >
                  <div className="bg-gray-100 h-40 sm:h-48 md:h-52 w-full flex justify-center items-center">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="p-4 text-center text-gray-700">
                    <h3 className="text-md font-semibold">{product.name}</h3>
                    <button
                      onClick={() => openModal(product)}
                      className="mt-4 px-4 py-2 rounded-full text-sm font-semibold bg-[#14242c] hover:bg-[#1c76a4] text-white"
                    >
                      View Details
                    </button>
                  </div>
                </div>
              ))}
          </div>
          {currentIndex + itemsToShow < filteredProducts.length && (
            <button
              onClick={handleNext}
              className="absolute right-0 text-gray-700 p-2 text-2xl hover:text-gray-900 transition-colors"
            >
              {'>'}
            </button>
          )}
        </div>

        {/* Mobile View */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:hidden px-4">
          {filteredProducts.slice(0, visibleProducts).map((product, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col justify-between"
            >
              <div className="bg-gray-100 h-44 sm:h-48 w-full flex justify-center items-center">                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-4 text-center">
              <h3 className="text-md font-semibold text-gray-700 truncate">{product.name}</h3>
                <button
                  onClick={() => openModal(product)}
                  className="mt-2 px-4 py-2 rounded-full text-sm font-semibold bg-[#14242c] text-white"
                >
                  View Details
                </button>
              </div>
            </div>
          ))}
        </div>

        {visibleProducts < filteredProducts.length && (
          <div className="text-center mt-6 md:hidden">
            <button
              onClick={handleSeeMore}
              className="bg-[#0a354a] hover:bg-[#1c76a4] text-white py-2 px-8 rounded-full text-sm"
            >
              See More
            </button>
          </div>
        )}
      </div>

      {/* Product Modal */}
      {modalProduct && !showTopDriDetails && (
  <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center px-4 overflow-y-auto">          
    <div className="bg-white rounded-lg shadow-lg w-full max-w-3xl relative p-6 max-h-[90vh] overflow-y-auto">
      <button onClick={closeModal} className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl font-bold">
        ×
      </button>

      <div className="flex flex-col md:flex-row gap-6">
        {/* Left Section: Scrollable Images */}
        <div className="flex flex-col items-center w-full md:w-1/2 max-h-[50vh] overflow-y-auto">
          <img src={modalProduct.image} alt={modalProduct.name} className="w-full h-64 object-cover rounded-lg" />
          {/* Thumbnails */}
          <div className="flex space-x-2 mt-4 overflow-x-auto">
            {modalProduct.images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Thumbnail ${index + 1}`}
                className="w-16 h-16 object-cover rounded-lg cursor-pointer border border-gray-300 hover:border-blue-500"
                onClick={() => setModalProduct({ ...modalProduct, image: img })}
              />
            ))}
          </div>
        </div>

        {/* Right Section: Scrollable Description */}
        <div className="w-full md:w-1/2 max-h-[50vh] overflow-y-auto">
          <h3 className="text-2xl font-bold text-gray-800 mb-4">{modalProduct.name}</h3>
          {modalProduct.description.map((paragraph, index) => (
            <p key={index} className="text-gray-600 mb-4 text-justify">{paragraph}</p>
          ))}

          <div className="flex flex-wrap gap-3 mt-4 justify-center">
            <button 
              onClick={() => {
                document
                  .getElementById('contact-us')
                  .scrollIntoView({ behavior: 'smooth' });
                closeModal(); // Close the modal when Inquiry button is clicked
              }}
              className="px-4 py-2 rounded-full text-sm font-semibold bg-[#14242c] text-white hover:bg-[#1c76a4]">
              Inquiry
            </button>

            {modalProduct?.name === 'Top Dri Container Desiccants' && (
              <button onClick={openTopDriDetails} className="px-4 py-2 rounded-full text-sm font-semibold bg-[#e5a00d] hover:bg-[#d48c0b] text-white">
                Know More
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
      )}


      {/* Top Dri Extended Modal */}
      <TopDriModal 
        show={showTopDriDetails} 
        onClose={() => setShowTopDriDetails(false)} 
        onCloseAll={() => {
          setShowTopDriDetails(false);
          setModalProduct(null);
          document.body.style.overflow = 'auto';
        }}
      />
      
    </section>
  );
};

export default Products;
